
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "deleteAccount",
      resolverType: "mutation",
      routePath: "/deleteAccount",
      httpMethod: "POST",
    });
  